import { useTranslation } from "react-i18next"
import Select from "react-select"
import classes from "./Database.module.css"
import {
    default_multi_style,
    get_ability_labels,
    get_brand_labels,
    get_fresh_labels,
    get_seed_labels,
} from "../../Utils"

const DatabaseControls = props => {
    const { t } = useTranslation()

    const abilityLabels = get_ability_labels(t)
    const brandLabels = get_brand_labels(t)
    const freshLabels = get_fresh_labels(t, classes)
    const seedLabels = get_seed_labels(t)
    const ms = default_multi_style()

    return (
        <div className={classes.Wrapper}>
            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("translation:LayoutMsg.Cmn_CstBase_00.001")}</span>
                <div className={classes.MultiSelect}>
                    <Select
                        defaultValue={abilityLabels}
                        isMulti
                        name="ability"
                        options={abilityLabels}
                        value={props.abilitiesToShow}
                        onChange={props.setAbilitiesToShow}
                        styles={ms}
                        formatOptionLabel={elem => {
                            const url = `https://leanny.github.io/splat3/images/skill/${elem.value}.png`
                            return (
                                <div className={classes.Entry} key={elem.value}>
                                    {elem.value !== "None" ? (
                                        <img src={url} alt={elem.label} className={classes.Ability} />
                                    ) : (
                                        ""
                                    )}
                                    <span className={classes.displayText}>
                                        <span className={classes.Gap}>{elem.label}</span>{" "}
                                    </span>
                                </div>
                            )
                        }}
                    />
                </div>
            </div>
            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("translation:LayoutMsg.Cmn_CstBase_00.002")}</span>
                <div className={classes.MultiSelect}>
                    <Select
                        defaultValue={brandLabels}
                        isMulti
                        name="brand"
                        value={props.brandsToShow}
                        onChange={props.setBrandsToShow}
                        options={brandLabels}
                        styles={ms}
                        formatOptionLabel={elem => {
                            const url = `https://leanny.github.io/splat3/images/brand/${elem.value}.png`
                            return (
                                <div className={classes.Entry} key={elem.value}>
                                    {elem.value !== "None" ? (
                                        <img src={url} alt={elem.label} className={classes.Brand} />
                                    ) : (
                                        ""
                                    )}
                                    <span className={classes.displayText}>
                                        <span className={classes.Gap}>{elem.label}</span>
                                    </span>
                                </div>
                            )
                        }}
                    />
                </div>
            </div>
            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("translation:LayoutMsg.Cmn_CstBase_00.000")}</span>
                <div className={classes.MultiSelect}>
                    <Select
                        defaultValue={freshLabels}
                        isMulti
                        name="fresh"
                        options={freshLabels}
                        styles={ms}
                        value={props.favoriteToShow}
                        onChange={props.setFavoriteToShow}
                    />
                </div>
            </div>
            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("misc:Common.Seed")}</span>
                <div className={classes.MultiSelect}>
                    <Select
                        defaultValue={seedLabels}
                        isMulti
                        name="seed"
                        styles={ms}
                        options={seedLabels}
                        value={props.seedsToShow}
                        onChange={props.setSeedsToShow}
                    />
                </div>
            </div>
            <div>
                <button className={classes.ButtonSimple} onClick={() => props.setNewGear(true)}>
                    {t("misc:Database.AddNewGear")}
                </button>
            </div>
        </div>
    )
}

export default DatabaseControls
